export const ALL_STAGES = [
    'import', 'form-recognition', 'batch-fix', 'ocr', 'post-ocr',
    'key-entry', 'verification', 'qa', 'supervisor', 'pre-export', 'export',
];
/**
 * F-036/E-032 — the stages where operators edit field data, i.e. where check
 * rules can meaningfully fire on entry. Multi-stage rule authoring offers
 * exactly these; legacy single-stage 'verification' rules expand to them (see
 * effectiveValidateStages in rule-attachment.ts).
 */
export const EDIT_CAPABLE_STAGES = [
    'key-entry', 'verification', 'qa', 'supervisor',
];
// F-024 — moved to step-stage.ts, the canonical step↔stage module. Re-exported
// here so existing import sites (e.g. stage-bridge.test.ts) keep working.
export { stageForStep } from "../step-stage.js";
export const isPopulateBehavior = (b) => b.kind === 'populate';
export const isComputeBehavior = (b) => b.kind === 'compute';
export const isWebhookBehavior = (b) => b.kind === 'webhook';
//# sourceMappingURL=behaviors.js.map